import { useTranslation } from 'react-i18next';

export const useCommonTranslation = () => useTranslation('common');
